import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {PasswordService} from '../../../services/apiServices/security/password.service';
import {ConfirmationService, SelectItemGroup} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {AuthenticationService} from '../../../services/apiServices/security/authentication.service';
import {StorageService} from '../../../services/storage/storage.service';
import {User} from '../../../model/user';
import {CommonService} from '../../../services/apiServices/business/common.service';
import {TemplatesConfig} from "../../../model/templatesConfig";
import {UserManagementService} from "../../../services/apiServices/business/user-management.service";
import {JwtHelperService} from "@auth0/angular-jwt";

interface Feature {
  id: number;
  name: string;
}

// noinspection JSUnusedLocalSymbols
/**
 * base on the create-password component, give to an authenticated user the ability to change his password
 */
@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss']
})

export class ConfigurationComponent implements OnInit {

  /**
   * current user's password
   */
  @Output() impersonateEnd: EventEmitter<boolean>;
  public actualPassword: string;


  /**
   * new password
   */
  public newPassword: string;

  /**
   * new password confirmation
   */
  public verifyPassword: string;

  /**
   * if the change of password fail
   */
  public changePasswordFail: boolean;

  /**
   * if the new password is valid or not
   */
  public isNewPasswordValid: boolean;
  public isNewPasswordConfirmValid: boolean;

  /**
   * message when the change of password fail (gave by the back-office)
   */
  public errorMessage: string;

  /**
   * Message display when the new password is ok
   */
  public successMessage: string;
  public resetModSuccessMsg: string;
  public resetModFailureMsg: string;
  public saveModSuccessMsg: string;
  public saveModFailureMsg: string;

  /**
   * Title of the message, displayed when operations succeed
   */
  public successTitle: string;
  /**
   * Title of the message, display when operations fails
   */
  public errorTitle: string;

  /**
   * Title of message display on removal params confirmation
   */
  private removalConfirmationHeader: string;

  /**
   * Message display on removal params confirmation
   */
  private removalConfirmationMessage: string;
  public passwordInvalidMsg: string;
  public passwordConfirmInvalidMsg: string;

  /**
   * Current logged user
   */
  public currentUser: User;
  isAdminNumen = false;
  isAdminErl = false;
  isAdminEmail = false;
  isAdminExpress = false;
  isAdminLog = false;
  impersonated = false;
  impersonatedConfLoding = false;
  activeIndex: number;

  /**
   * Feature management dropdown
   */
  public features: Feature[] = [];
  public selectedFeature: Feature | undefined;

  public isWsoRegistered: boolean;
  jwtHelper: JwtHelperService;

  constructor(private passwordService: PasswordService,
              private translate: TranslateService, private authenticationService: AuthenticationService,
              private confirmationService: ConfirmationService, private storageService: StorageService,
              private commonService: CommonService, private userManagementService: UserManagementService) {
    this.impersonateEnd = new EventEmitter();
    this.jwtHelper = new JwtHelperService()
  }

  /**
   * handleChangeOfSelectFold the subscriptions to the errorMessage from passwordService
   *
   */
  public ngOnInit(): void {
    this.isNewPasswordValid = true;
    this.isNewPasswordConfirmValid = true;
    this.currentUser = this.authenticationService.getCurrentUser();
    this.changePasswordFail = false;
    this.isAdminNumen = this.authenticationService.isAdminNumen();
    this.isAdminErl = this.authenticationService.isAdminErl();
    this.isAdminEmail = this.authenticationService.isAdminEmail();
    this.isAdminExpress = this.authenticationService.isAdminExpress();
    this.features.push({id: 1, name: this.translate.instant('CONFIGURATION_COMPONENT.FEATURE_DEPOSIT')})
    if (this.isAdminErl || this.isAdminNumen){
      this.features.push({id: 2, name: this.translate.instant('CONFIGURATION_COMPONENT.FEATURE_ERL')})
    }
    if (this.isAdminEmail || this.isAdminNumen){
      this.features.push({id: 3, name: this.translate.instant('CONFIGURATION_COMPONENT.FEATURE_EMAIL')})
    }
    this.selectedFeature = this.features[0];
    this.isAdminLog = this.authenticationService.isAdminLog();
    this.impersonated = this.authenticationService.isImpersonnated();

    this.passwordService.errorMessage.subscribe(
      error => {
        this.errorMessage = error;
      }
    );
    this.getTradForComponent();
    this.authenticationService.isLogged.subscribe(logged => {
      if (logged) {
        this.currentUser = this.authenticationService.getCurrentUser();
      } else {
        this.currentUser = null;
      }
    });

    if (localStorage.getItem('wsoAccessToken').length > 0 || localStorage.getItem('hasBeenWsoLoggedIn') == 'true'){
      this.isWsoRegistered = true;
    } else {
      this.isWsoRegistered = false;
    }
  }

  /**
   * Reset all application param to original state for the current user
   */
  public resetApplication(): void {
    this.confirmationService.confirm({
      message: this.removalConfirmationMessage,
      header: this.removalConfirmationHeader,
      accept: () => {
        this.storageService.removeFoldDatatablesParamsFromStorage(this.authenticationService.userLogged);
        this.authenticationService.logout();
        window.location.reload();
      }
    });

  }

  /**
   *
   * check is all the form is valid (allowing user to click on login)
   *
   * @return {boolean} - true if the form is complete, false else
   */
  public formIsComplete(): boolean {
    return this.actualPassword && this.isNewPasswordValid && this.isNewPasswordConfirmValid;
  }

  /**
   * handleChangeOfSelectFold the change of password, it'll display a message if it's a false, else it'll log-out the user
   */
  public changePassword(): void {
    this.passwordService.changePassword(this.actualPassword, this.newPassword, this.verifyPassword).subscribe(result => {
      this.changePasswordFail = !result;
      if (result) {
        this.commonService.addToast({life: 3000, severity: 'success', summary: this.successTitle, detail: this.successMessage});
        this.authenticationService.logout();
      }
    });
  }

  public askWsoPasswordReset(): void {
    const decodedToken = this.jwtHelper.decodeToken(localStorage.getItem('wsoAccessToken'));
    const userName: string = decodedToken.username;
    this.userManagementService.getWsoUserIdByUsername(userName).subscribe(userId => {
      if (userId.length > 0){
        this.userManagementService.askWsoResetPassword(userId).subscribe(result => {})
      }
    })
  }

  /**
   * obtain translation from TranslateService
   */
  public getTradForComponent(): void {
    this.translate.get('TOASTER.SUCCESS_MESSAGE_TITLE').subscribe((title: string) => {
      this.successTitle = title;
    });
    this.translate.get('TOASTER.ERROR_MESSAGE_TITLE').subscribe((title: string) => {
      this.errorTitle = title;
    });
    this.translate.get('TOASTER.MODIFY_PASSWORD_ASK_OK').subscribe((message: string) => {
      this.successMessage = message;
    });
    this.translate.get('CONFIGURATION_COMPONENT.RESET_MOD_SUCCESS').subscribe((message: string) => {
      this.resetModSuccessMsg = message;
    });
    this.translate.get('CONFIGURATION_COMPONENT.RESET_MOD_FAILURE').subscribe((message: string) => {
      this.resetModFailureMsg = message;
    });
    this.translate.get('CONFIGURATION_COMPONENT.SAVE_MOD_SUCCESS').subscribe((message: string) => {
      this.saveModSuccessMsg = message;
    });
    this.translate.get('CONFIGURATION_COMPONENT.SAVE_MOD_FAILURE').subscribe((message: string) => {
      this.saveModFailureMsg = message;
    });

    this.translate.get('CONFIGURATION_COMPONENT.RESET_PARAMS_CONFIRMATION_MESSAGE').subscribe((translation: string) => {
      this.removalConfirmationMessage = translation;
    });
    this.translate.get('CONFIGURATION_COMPONENT.RESET_PARAMS_CONIFRMATION_HEADER').subscribe((translation: string) => {
      this.removalConfirmationHeader = translation;
    });
    this.translate.get('CREATE.PASSWORD_COMPONENT.INPUT_PROMPT_LABEL').subscribe(message => {
      this.passwordInvalidMsg = message;
    });
    this.translate.get('CREATE.PASSWORD_COMPONENT.COFIRM_IDENTICAL').subscribe(message => {
      this.passwordConfirmInvalidMsg = message;
    });
  }

  public terminateImpersonate(): void {
    this.authenticationService.terminateImpersonation().subscribe(response => {
      this.impersonateEnd.emit(response);
    });
  }

  handleUserImpersonated($event) {
    this.impersonateEnd.emit(false);
  }

  protected readonly localStorage = localStorage;
}
